/* global axios */
import ApiClient from './ApiClient';

class TalkviaStoreAPI extends ApiClient {
  constructor() {
    super('talkvia_store', { accountScoped: true });
  }

  purchase(items) {
    return axios.post(`${this.url}/purchase`, { items });
  }

  purchaseCredits(productId, units) {
    return axios.post(`${this.url}/purchase_credits`, {
      product_id: productId,
      units,
    });
  }
}

export default new TalkviaStoreAPI();
